import useAbility from '@/hooks/use-ability'
import UpgradeLayout from './upgrade-layout'

export default function ExecutiveSummary({ executiveSummaries, isDemoUser }) {
  const { checkAbility } = useAbility()

  const enableSubbasinInformation = checkAbility(
    'subbasin_information_name_number'
  )
  const enableSubbasinExecutive = checkAbility('subbasin_executive_summaries')

  if (enableSubbasinInformation === false) {
    return (
      <div className="min-h-[120px] h-full relative">
        <UpgradeLayout
          title="Upgrade to view Executive Summary."
          needUpgrade={true}
        />
      </div>
    )
  }

  if (Object.keys(executiveSummaries).length === 0)
    return <p className="ml-[30px] ">No Executive Summary for this parcel</p>
  else
    return (
      <>
        {Object.entries(executiveSummaries).map(([subbasinNo, value]) => (
          <div key={subbasinNo} className="relative">
            <div className="ml-[30px] flex flex-row items-center text-bold">
              <strong>Water District(s):&nbsp;</strong>
              <div className="relative font-bold">
                <span className={`${isDemoUser ? 'blur' : ''}`}>
                  {value.wd_info.map((wd) => wd.wd_name).join(', ')}{' '}
                </span>
              </div>
            </div>
            {value.wd_info.some(
              (wd) =>
                wd.wd_executive_summary &&
                wd.wd_executive_summary.trim() !== '' &&
                wd.wd_executive_summary !== 'N/A'
            ) ? (
              <>
                <div className="ml-[30px] flex flex-row items-center text-bold">
                  <strong>Executive Summary:&nbsp;</strong>
                </div>
                <div className="min-h-[40px] h-full relative">
                  <UpgradeLayout
                    title="Upgrade to view Executive Summary."
                    needUpgrade={!enableSubbasinExecutive}
                  />
                  <div>
                    <p className="ml-[30px] mr-[30px]">
                      <span className={`${isDemoUser ? 'blur' : ''}`}>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: value.wd_info
                              .filter(
                                (wd) =>
                                  wd.wd_executive_summary &&
                                  wd.wd_executive_summary.trim() !== '' &&
                                  wd.wd_executive_summary !== 'N/A'
                              ) // Only include items with non-empty summaries
                              .map(
                                (wd) =>
                                  `${wd.wd_executive_summary} (${wd.wd_name})`
                              )
                              .join('<br />'),
                          }}
                        />
                      </span>
                    </p>
                    <br />
                  </div>
                </div>
              </>
            ) : (
              <br />
            )}
            <div className="ml-[30px] flex flex-row items-center text-bold">
              <strong>GSA(s):&nbsp;</strong>
              <div className="relative font-bold">
                <span className={`${isDemoUser ? 'blur' : ''}`}>
                  {value.gsa_info.map((gsa) => gsa.gsa_name).join(', ')}{' '}
                </span>
              </div>
            </div>
            {value.gsa_info.some(
              (gsa) =>
                gsa.gsa_allocation_status_update &&
                gsa.gsa_allocation_status_update.trim() !== '' &&
                gsa.gsa_allocation_status_update !== 'N/A'
            ) ? (
              <>
                <div className="ml-[30px] flex flex-row items-center text-bold">
                  <strong>Executive Summary:&nbsp;</strong>
                </div>
                <div className="min-h-[40px] h-full relative">
                  <UpgradeLayout
                    title="Upgrade to view Executive Summary."
                    needUpgrade={!enableSubbasinExecutive}
                  />
                  <div>
                    <p className="ml-[30px] mr-[30px]">
                      <span className={`${isDemoUser ? 'blur' : ''}`}>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: value.gsa_info
                              .filter(
                                (gsa) =>
                                  gsa.gsa_allocation_status_update &&
                                  gsa.gsa_allocation_status_update.trim() !==
                                    '' &&
                                  gsa.gsa_allocation_status_update !== 'N/A'
                              ) // Only include items with non-empty summaries
                              .map(
                                (gsa) =>
                                  `${gsa.gsa_allocation_status_update} (${gsa.gsa_name})`
                              )
                              .join('<br />'),
                          }}
                        />
                      </span>
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <br />
            )}

            <div className="ml-[30px] flex flex-row items-center text-bold">
              <strong>Subbasin:&nbsp;</strong>
              <div className="relative font-bold">
                <span className={`${isDemoUser ? 'blur' : ''}`}>
                  {value.subbasin_name} ({value.subbasin_no})
                </span>
              </div>
            </div>

            {(value.subbasin_status_update &&
              value.subbasin_status_update != 'N/A') ||
            (value.executive_summary && value.executive_summary != 'N/A') ? (
              <>
                <div className="ml-[30px] flex flex-row items-center text-bold">
                  <strong>Executive Summary:&nbsp;</strong>
                </div>
                <div className="min-h-[40px] h-full relative">
                  <UpgradeLayout
                    title="Upgrade to view Executive Summary."
                    needUpgrade={!enableSubbasinExecutive}
                  />
                  <div>
                    {value.subbasin_status_update &&
                      value.subbasin_status_update != 'N/A' && (
                        <>
                          <p className="ml-[30px] mr-[30px]">
                            <span className={`${isDemoUser ? 'blur' : ''}`}>
                              {' '}
                              {value.subbasin_status_update}{' '}
                            </span>
                          </p>
                          <br />
                        </>
                      )}
                    {value.executive_summary &&
                      value.executive_summary != 'N/A' && (
                        <>
                          <p className="ml-[30px] mr-[30px]">
                            <span className={`${isDemoUser ? 'blur' : ''}`}>
                              {value.executive_summary}
                            </span>
                          </p>
                          <br />
                          <br />
                        </>
                      )}
                  </div>
                </div>
              </>
            ) : (
              <br />
            )}

            <br />
          </div>
        ))}
      </>
    )
}
